// Generate edges based on parent-child relationships, supporting multiple root nodes
const generateEdgesFromParentChild = (nodes) => {
  const findRootNodes = (nodes) => {
    return nodes.filter(node => node.data.parent === null);
  };

  // for the child nodeIds, find the actual node, and recursively do that
  // until you have no childIds left 
  const connectParentToChildren = (nodes, parentId, edges = []) => {
    const parentNode = nodes.find(node => node.id === parentId);
    
    if (parentNode && parentNode.data.children && parentNode.data.children.length > 0) {
      const childEdges = parentNode.data.children.map(childId => ({
        id: `e${parentId}-${childId}`,
        source: parentId,
        target: childId,
        animated: true
      }));
      
      // Add all the edges at once
      edges.push(...childEdges);
      
      // Recursively process each child
      parentNode.data.children.forEach(childId => {
        connectParentToChildren(nodes, childId, edges);
      });
    }
    
    return edges;
  };

  // Start with all root nodes and build trees for each
  const rootNodes = findRootNodes(nodes);
  if (rootNodes.length === 0) return [];
  
  let allEdges = [];
  
  // Process each root node to build its tree
  rootNodes.forEach(rootNode => {
    const treeEdges = connectParentToChildren(nodes, rootNode.id);
    allEdges = [...allEdges, ...treeEdges];
  });

  return allEdges;
};

export default generateEdgesFromParentChild;
